export default __webpack_public_path__ + "static/media/HeroImageInterShop.370f8294.png";